import $ from 'jquery';

$(() => {
  $('.checkout-summary-terms-and-conditions').on('click', (e) => {
    e.preventDefault();
    $('#checkoutTermsAndConditionModal').modal('toggle');
  });
});
